/* eslint-disable max-len */
import * as React from 'react';

const AddImage = (props) => (
  <svg
    width={27}
    height={26}
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1101_4525)">
      <path
        d="M10.6557 19.1179C10.8535 19.3706 11.0541 19.6267 11.2585 19.8871V20.7821L11.8853 19.9903C12.2231 19.5637 12.556 19.1437 12.8851 18.7285C13.733 17.6589 14.5557 16.621 15.3709 15.5834C15.548 15.3606 15.6874 15.2124 15.8029 15.1208C15.9172 15.0303 15.9808 15.0168 16.0115 15.016C16.0394 15.0152 16.0961 15.0231 16.2012 15.1027C16.3096 15.185 16.4421 15.323 16.6118 15.5371L16.6118 15.5372C17.8064 17.0439 18.9988 18.5477 20.1627 20.0711C20.2205 20.1481 20.281 20.271 20.3144 20.3947C20.3308 20.4553 20.338 20.5063 20.3385 20.5438C20.3387 20.558 20.338 20.5679 20.3372 20.5742C20.3299 20.5827 20.3165 20.5963 20.2941 20.614C20.2563 20.6438 20.2048 20.6757 20.1431 20.7051C20.0159 20.7658 19.8837 20.7984 19.7979 20.8009C15.0642 20.8276 10.3234 20.8275 5.58965 20.8009V20.8009H5.58767C5.5195 20.8009 5.40488 20.7719 5.28228 20.7064C5.1742 20.6488 5.09936 20.5839 5.06229 20.5371C5.06229 20.5371 5.06229 20.537 5.06229 20.5369C5.06225 20.5106 5.06748 20.4683 5.08256 20.4129C5.1135 20.2992 5.17072 20.1844 5.22124 20.1177L5.22124 20.1177L5.22247 20.1161C6.06168 18.9948 6.94344 17.8927 7.82939 16.7853C8.10635 16.4405 8.25382 16.3884 8.31783 16.3877C8.37912 16.3871 8.52403 16.433 8.79995 16.7733C9.41746 17.5363 10.0228 18.3095 10.6557 19.1179ZM5.06326 20.5526C5.06324 20.5526 5.06311 20.552 5.06296 20.5508L5.06326 20.5526Z"
        fill="#626F86"
        stroke="#626F86"
        strokeWidth={0.702703}
      />
    </g>
    <rect
      x={1.2027}
      y={3.36969}
      width={23.1892}
      height={21.9279}
      rx={2.10811}
      stroke="#626F86"
      strokeWidth={1.40541}
    />
    <rect width={14.0541} height={13.3333} transform="translate(12.4453)" fill="white" />
    <path
      d="M14.5527 7.02634H24.3906M19.4717 11.9453V2.10742"
      stroke="#626F86"
      strokeWidth={1.40541}
      strokeLinecap="round"
    />
    <defs>
      <clipPath id="clip0_1101_4525">
        <rect
          width={15.9795}
          height={6.50667}
          fill="white"
          transform="translate(4.71484 14.6665)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default AddImage;
